import { render, staticRenderFns } from "./Screen4d.vue?vue&type=template&id=2ff23e40&scoped=true&"
import script from "./Screen4d.vue?vue&type=script&lang=js&"
export * from "./Screen4d.vue?vue&type=script&lang=js&"
import style0 from "./Screen4d.vue?vue&type=style&index=0&id=2ff23e40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff23e40",
  null
  
)

export default component.exports